import { useState } from 'react';
import { Link } from 'react-router-dom';
import { resolveDday, resolveThumbnail } from './CampaignCard';
import styles from './CampaignRowCard.module.css';

function ddayLabel(dday) {
  if (dday === null || dday === undefined) return null;
  if (dday < 0) return '마감';
  if (dday === 0) return 'D-DAY';
  return `D-${dday}`;
}

/** 좁은 열에 쌓아 쓰는 가로형 카드. 스포트라이트 섹션의 보조 목록용. */
export default function CampaignRowCard({ campaign }) {
  const [loaded, setLoaded] = useState(false);
  const [failed, setFailed] = useState(false);

  const { id, title, brandName, recruitCount } = campaign;
  const thumbnail = resolveThumbnail(campaign);
  const dday = resolveDday(campaign);
  const label = ddayLabel(dday);
  const urgent = dday !== null && dday !== undefined && dday >= 0 && dday <= 3;

  return (
    <Link className={styles.row} to={`/campaign/${id}`}>
      <div className={styles.thumb}>
        {thumbnail && !failed && (
          <img
            className={`${styles.thumbImg}${loaded ? ` ${styles.thumbImgLoaded}` : ''}`}
            src={thumbnail}
            alt={title}
            loading="lazy"
            decoding="async"
            onLoad={() => setLoaded(true)}
            onError={() => setFailed(true)}
          />
        )}
      </div>

      <div className={styles.info}>
        {brandName && <p className={styles.brand}>{brandName}</p>}
        <p className={styles.name}>{title}</p>
        <p className={styles.meta}>
          {label && (
            <span className={`${styles.dday}${urgent ? ` ${styles.ddayUrgent}` : ''}`}>{label}</span>
          )}
          <span>{recruitCount ?? 0}명 모집</span>
        </p>
      </div>
    </Link>
  );
}
